import { GetPastConferencesDataType } from '@/api/conference';
import { Forum, Gallery, Newsletter, Notice, Trend } from '@/api/notice';

export interface ColumnDef {
	key: string;
	title: string;
}

const COLUMN_MAP = {
	title: ['gallery_title', 'notice_title', 'newsletter_title', 'trend_title', 'guide_title', 'forum_title'],
	hit: ['gallery_hit', 'notice_hit', 'newsletter_hit', 'trend_hit', 'guide_hit', 'forum_hit'],
	enrollment_date: [
		'gallery_enrollment_date',
		'notice_enrollment_date',
		'newsletter_enrollment_date',
		'trend_enrollment_date',
		'guide_enrollment_date',
		'forum_enrollment_date',
	],
	admin: ['admin_name'],
};

export const generateColumns = (data: (Gallery | Notice | Forum | Newsletter | Trend | GetPastConferencesDataType)[]): ColumnDef[] => {
	if (data.length === 0) return [];

	const sample = data[0];

	const getAvailableKey = (keys: string[]) => keys.find((key) => key in sample) || '';

	return [
		{ key: 'no', title: 'information.table.no' },
		{ key: getAvailableKey(COLUMN_MAP.title), title: 'information.table.title' },
		{ key: getAvailableKey(COLUMN_MAP.admin), title: 'information.table.author' },
		{ key: getAvailableKey(COLUMN_MAP.hit), title: 'information.table.views' },
		{ key: getAvailableKey(COLUMN_MAP.enrollment_date), title: 'information.table.date' },
	].filter((col) => col.key);
};
